import React from "react";
import { Box } from "@mui/material";

import { SidebarSectionType } from "../../types/sidebar";
import SidebarNavSection from "./SidebarNavSection";

type SidebarNavProps = {
  items: SidebarSectionType[];
  collapsed?: boolean;
  id?: string;
  /** Called after a nav item is chosen (closes the mobile drawer). */
  onNavigate?: () => void;
};

const SidebarNav: React.FC<SidebarNavProps> = ({
  items,
  collapsed = false,
  id,
  onNavigate,
}) => (
  <Box
    component="nav"
    id={id}
    aria-label="Main navigation"
    sx={{
      flexGrow: 1,
      overflowY: "auto",
      px: 2,
      py: 2.5,
      display: "grid",
      alignContent: "start",
      gap: 0.5,
    }}
  >
    {items.map((section) => (
      <SidebarNavSection
        key={section.title}
        pages={section.pages}
        title={section.title}
        collapsed={collapsed}
        onNavigate={onNavigate}
      />
    ))}
  </Box>
);

export default SidebarNav;
